<template>
  <div class="content-body tenant-settings">
    <div class="">
      <el-form :inline="true" size="small" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item label="工厂:" label-width="100px">
          <el-select v-model="dataForm.werks" filterable clearable placeholder="请选择" @change="queryHandle">
            <el-option v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryCode"
                       :value="item.factoryCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="供应商名称:" label-width="100px">
          <el-input size="small" v-model="dataForm.name1" placeholder="供应商名称" clearable
                    @blur="queryHandle"></el-input>
        </el-form-item>
        <el-form-item label="结算单号:" label-width="100px">
          <el-input size="small" v-model="dataForm.zjsdh" placeholder="结算单号" clearable
                    @blur="queryHandle"></el-input>
        </el-form-item>
        <el-form-item label="结算区间日期:" label-width="100px">
          <el-date-picker v-model="dataForm.deadlineDate" unlink-panels type="daterange" value-format="yyyy-MM-dd"
                          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable
                          @blur="queryHandle">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="财务状态:" label-width="100px">
          <el-select v-model="dataForm.zstatus" filterable clearable placeholder="请选择" @change="queryHandle">
            <el-option v-for="item in ACCOUNT_STATUS" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算单类型:" label-width="100px">
          <el-select v-model="dataForm.ztype" filterable clearable placeholder="请选择" @change="queryHandle">
            <el-option v-for="item in ACCOUNT_TYPE_VALUE" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发票号:" label-width="100px">
          <el-input size="small" v-model="dataForm.invoiceNo" placeholder="发票号" clearable
                    @blur="queryHandle"></el-input>
        </el-form-item>
        <el-form-item label="发布区间日期:" label-width="100px">
          <el-date-picker
              v-model="dataForm.zpub"
              unlink-panels
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable
              @change="handlePublishDateChange"
              @blur="queryHandle">
          </el-date-picker>
        </el-form-item>

        <el-form-item class="fr">
          <el-button size="small" @click="queryHandle()" icon="el-icon-search">
            查询
          </el-button>
          <el-button size="small" plain type="primary" :loading="exporting" :disabled="exporting" @click="exportData()">
            批量导出
          </el-button>
          <!-- <el-button size="small" plain type="primary" @click="pushEmail()" icon="el-icon-plus">
              补发邮件
          </el-button> -->
        </el-form-item>
      </el-form>
      <div v-loading="dataListLoading">
        <el-table :data="dataList" row-key="id" size="mini" style="width: 100%;" border :height="tableHeight"
                  :header-cell-style="{background:'#f5f5f5'}" :default-expand-all="false"
                  @selection-change="selectionChangeHandle">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column type="index" width="50" label="序号">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column prop="werks" header-align="center" align="center" label="工厂" width="50">
          </el-table-column>
          <el-table-column prop="name2" header-align="center" align="center" label="工厂名称" width="150">
          </el-table-column>
          <el-table-column prop="zjsdh" header-align="center" align="center" label="结算单号" width="150">
          </el-table-column>
          <el-table-column prop="ztype" header-align="center" align="center" label="结算单类型" width="100">
            <template slot-scope="scope">
                        <span>
                            {{ accountTypeFormat(scope.row.ztype) }}
                        </span>
            </template>
          </el-table-column>
          <el-table-column prop="lifnr" header-align="center" align="center" label="供应商代码" width="100">
          </el-table-column>
          <el-table-column prop="name1" header-align="center" align="center" label="供应商名称" width="220">
          </el-table-column>
          <el-table-column prop="zhszje" header-align="center" align="center" label="含税总金额" width="100">
            <template slot-scope="scope">
                        <span>
                            {{ scope.row.zhszje|rounding }}
                        </span>
            </template>
          </el-table-column>
          <el-table-column prop="zbhszje" header-align="center" align="center" label="不含税总金额" width="100">
            <template slot-scope="scope">
                        <span>
                            {{ scope.row.zbhszje|rounding }}
                        </span>
            </template>
          </el-table-column>
          <el-table-column prop="zbadutl" header-align="center" align="center" label="结算起始日期"
                           :formatter="dateFormat" width="100">
          </el-table-column>
          <el-table-column prop="zbaduth" header-align="center" align="center" label="结算终止日期"
                           :formatter="dateFormat" width="100">
          </el-table-column>
          <el-table-column prop="zkptzrq" header-align="center" align="center" label="开票通知日期"
                           :formatter="dateFormat" width="100">
          </el-table-column>
          <el-table-column prop="zpub" header-align="center" align="center" label="发布日期时间"
                           :formatter="dateTimeFormat" width="150">
          </el-table-column>
          <el-table-column prop="createdate" header-align="center" align="center" label="建立日期"
                           :formatter="dateFormat" width="100">
          </el-table-column>
          <el-table-column prop="username" header-align="center" align="center" label="建立账号" width="100">
          </el-table-column>
          <el-table-column prop="zstatus" header-align="center" align="center" label="财务状态" width="100">
            <template slot-scope="scope">
                        <span>
                            {{ accountStatusFormat(scope.row.zstatus) }}
                        </span>
            </template>
          </el-table-column>
          <el-table-column prop="zjsyy" header-align="center" align="center" label="原因" width="100">
          </el-table-column>
          <el-table-column header-align="center" align="left" width="150" label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-edit">
                查看
              </el-button>
              <el-button type="text" size="small" @click="editHandle(scope.row)" icon="el-icon-edit">
                编辑发票
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                     :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
      <!-- 弹窗, 查看结算单明细 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
      <invoice-add-or-update v-if="invoiceAddOrUpdateVisible" ref="invoiceAddOrUpdate"
                             @refreshDataList="getDataList"></invoice-add-or-update>
    </div>
  </div>
</template>

<script>
import {
  list,
  exportSettlementData,
  exportSettlementDataAsync,
  getExportTask,
  downloadExportFile,
  pushEmail,
  // list
} from '@/controller/settlement'
import {
  getFactoryList,
} from '@/controller/systemData'
import {
  getLabelByValue,
  ACCOUNT_TYPE_VALUE,
  ACCOUNT_STATUS_VALUE,
  ACCOUNT_STATUS
} from '@/utils/const'
import AddOrUpdate from './settlement-add-or-update'
import InvoiceAddOrUpdate from './invoice-add-or-update'
import moment from 'moment'

export default {
  created() {
    this.setDefaultDateRange();
  },
  data() {
    return {
      documentClientHeight: document.documentElement['clientHeight'] - 250,
      factoryList: [],//工厂数据集合
      dataForm: {
        lifnr: '',
        name1: '',
        zjsdh: '',
        zkptzrq: '',
        zhszje: '',
        zbhszje: '',
        werks: '',
        name2: '',
        ztype: '',
        payDate: '',
        deadlineDate: '',
        zstatus: '',
        invoiceNo: '',//发票号
        zpub: [],
      },
      dataList: [],
      tenantList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      getLabelByValue: getLabelByValue,
      ACCOUNT_STATUS: ACCOUNT_STATUS,
      ACCOUNT_TYPE_VALUE: ACCOUNT_TYPE_VALUE,
      dataListLoading: false,
      dataListSelections: [],
      exporting: false,
      addOrUpdateVisible: false,
      invoiceAddOrUpdateVisible: false
    }
  },
  computed: {
    tableHeight: {
      get() {
        return this.$store.state.common.documentClientHeight - 260
      }
    }
  },
  components: {
    AddOrUpdate,
    InvoiceAddOrUpdate
  },
  activated() {
    this.getDataList()
  },
  filters: {
    rounding(value) {
      return value.toFixed(2)
    }
  },
  methods: {
    handlePublishDateChange(value) {
      if (value && value.length === 2) {
        const startDate = new Date(value[0]);
        const endDate = new Date(value[1]);

        // 计算两个日期之间的月份差
        const yearDiff = endDate.getFullYear() - startDate.getFullYear();
        const monthDiff = endDate.getMonth() - startDate.getMonth();
        const totalMonthDiff = yearDiff * 12 + monthDiff;

        // 如果超过一个月，调整结束日期为开始日期后一个月
        if (totalMonthDiff > 1 || (totalMonthDiff === 1 && endDate.getDate() > startDate.getDate())) {
          const maxEndDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, startDate.getDate());
          // 确保不超过今天
          const today = new Date();
          const finalEndDate = maxEndDate < today ? maxEndDate : today;

          this.dataForm.zpub = [value[0], this.formatDate(finalEndDate)];
          this.$message.warning('发布区间日期时间跨度不能超过一个月，已自动调整结束日期');
        }
      }
      this.queryHandle();
    },
    setDefaultDateRange() {
      const now = new Date();
      const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      const endOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());

      // 设置默认日期范围
      this.dataForm.zpub = [
        this.formatDate(startOfMonth),
        this.formatDate(endOfToday)
      ];
    },
    // 修改 formatDate 方法，确保能正确处理日期对象
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    dateFormat: function (row, column) {
      var date = row[column.property]
      if (date == undefined) {
        return ''
      }
      return moment(date).format("YYYY-MM-DD")
    },
    dateTimeFormat(row, column) {
      var date = row[column.property]
      if (date == undefined) {
        return ''
      }
      return moment(date).format("YYYY-MM-DD HH:mm:ss")
    },
    accountTypeFormat: function (value) {
      if (!value) {
        return ''
      }
      return getLabelByValue(ACCOUNT_TYPE_VALUE, value)
    },
    // 通过code 获取结算单状态
    accountStatusFormat: function (value) {
      if (!value) {
        return ''
      }
      return getLabelByValue(ACCOUNT_STATUS_VALUE, value)
    },
    // 新增或编辑子节点
    addChildHandle(id, parentId, parentName, parentNodePath) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(null, parentId, parentName, parentNodePath)
      })
    },
    // 查询按钮
    queryHandle() {
      this.pageIndex = 1;
      this.getDataList();
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      list({
        pageNo: this.pageIndex,
        pageSize: this.pageSize,
        'werks': this.dataForm.werks,
        'name1': this.dataForm.name1,
        'zjsdh': this.dataForm.zjsdh,
        'zbadutl': this.dataForm.deadlineDate == null ? this.dataForm.deadlineDate : this.dataForm.deadlineDate[0],//截止日区间开始
        'zbaduth': this.dataForm.deadlineDate == null ? this.dataForm.deadlineDate : this.dataForm.deadlineDate[1],//截止日区间结束
        'zstatus': this.dataForm.zstatus,//财务状态
        'invoiceNo': this.dataForm.invoiceNo,//发票号
        'ztype': this.dataForm.ztype,
        'zpubtl': this.dataForm.zpub == null ? this.dataForm.zpub : this.dataForm.zpub[0],//截止日区间开始
        'zpubth': this.dataForm.zpub == null ? this.dataForm.zpub : this.dataForm.zpub[1],//截止日区间开始
      }).then(data => {
        if (data && data.code === '00') {
          this.dataList = data.body.records
          this.totalPage = data.body.total
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.getFactoryListVue()
      }).catch((e) => {
        console.log(e)
      }).finally(() => {
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle(val) {
      this.dataListSelections = val
    },
    // 查看结算单明细
    viewHandle(row) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(row, row ? row.id : null, 'view')
      })
    },
    // 查看发票信息
    editHandle(row) {
      this.invoiceAddOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.invoiceAddOrUpdate.init(row, row ? row.id : null, 'edit')
      })
    },
    //获取工厂的数据
    getFactoryListVue() {
      getFactoryList({
        post: '',
        address: '',
        factoryDesc: '',
        factoryCode: '',
      }).then((data) => {
        if (data && data.code === '00') {
          this.factoryList = data.body
        }
      })
    },
    //查询条件导出（异步）
    async exportData() {
      if (this.dataForm.zpub == null || this.dataForm.zpub.length === 0) {
        this.$message.error('请输入发布区间日期')
        return
      }
      const params = {
        'werks': this.dataForm.werks,//工厂
        'name1': this.dataForm.name1,//供应商名称
        'zjsdh': this.dataForm.zjsdh,//结算单号
        'zbadutl': this.dataForm.deadlineDate == null ? this.dataForm.deadlineDate : this.dataForm.deadlineDate[0],//截止日区间开始
        'zbaduth': this.dataForm.deadlineDate == null ? this.dataForm.deadlineDate : this.dataForm.deadlineDate[1],//截止日区间结束
        'zstatus': this.dataForm.zstatus,//财务状态
        'ztype': this.dataForm.ztype,//结算单类型
        'invoiceNo': this.dataForm.invoiceNo,//发票号
        'zpubtl': this.dataForm.zpub == null ? this.dataForm.zpub : this.dataForm.zpub[0],//发布区间开始
        'zpubth': this.dataForm.zpub == null ? this.dataForm.zpub : this.dataForm.zpub[1],//发布区间结束
      }
      this.exporting = true
      try {
        // 1. 发起异步导出
        const resp = await exportSettlementDataAsync(params)
        if (!resp || resp.code !== '00') {
          this.$message.error((resp && resp.msg) || '导出失败')
          return
        }
        const taskId = resp.body
        // 2. 轮询任务状态
        const loading = this.$message({ message: '正在导出中，请稍候...', type: 'info', duration: 0 })
        await this.pollExportTask(taskId, loading)
      } catch (e) {
        this.$message.error('导出失败: ' + (e.message || '未知错误'))
      } finally {
        this.exporting = false
      }
    },
    //轮询导出任务状态（每2秒，最长10分钟）
    async pollExportTask(taskId, loading) {
      const maxRetries = 300
      const interval = 2000
      for (let i = 0; i < maxRetries; i++) {
        await new Promise(resolve => setTimeout(resolve, interval))
        try {
          const res = await getExportTask(taskId)
          if (!res || res.code !== '00') {
            continue
          }
          const task = res.body
          if (task.status === 'COMPLETED') {
            loading.close()
            if (!task.fileUrl) {
              this.$message.info('导出完成，但无符合条件的数据')
              return
            }
            this.$message.success(`导出完成，共 ${task.totalRows || 0} 条，正在下载...`)
            try {
                const blob = await downloadExportFile(task.id)
                // 后端在文件不存在/任务未正常完成时返回 JSON 错误体（application/json），
                // 识别后提示而非生成损坏的 xlsx 文件。
                if (blob && blob.type && blob.type.indexOf('application/json') >= 0) {
                    const text = await new Promise(resolve => {
                        const reader = new FileReader()
                        reader.onload = () => resolve(reader.result)
                        reader.readAsText(blob)
                    })
                    let msg = '导出文件不存在或任务未正常完成，请重新导出'
                    try {
                        const obj = JSON.parse(text)
                        if (obj && (obj.msg || obj.message)) msg = obj.msg || obj.message
                    } catch (e) { /* 非JSON，用默认文案 */ }
                    this.$message.error(msg)
                    return
                }
                const url = window.URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = '结算单信息.xlsx'
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
                window.URL.revokeObjectURL(url)
            } catch (e) {
                this.$message.error('下载失败')
            }
            return
          } else if (task.status === 'FAILED') {
            loading.close()
            this.$message.error('导出失败: ' + (task.errorMsg || '未知错误'))
            return
          }
          // PROCESSING：继续轮询
        } catch (e) {
          console.warn('轮询失败:', e.message)
        }
      }
      loading.close()
      this.$message.error('导出超时，请稍后重试')
    },
    readAsBinaryString(data) {
      // const name = decodeURI(res.headers['content-disposition'].split('filename=')[1]);
      // const blob = new Blob(content, {type: 'application/vnd.ms-excel;charset=utf-8'}); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
      const blob = this.str2Blob(data.content, 'application/vnd.ms-excel;charset=utf-8'); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
      const url = window.URL.createObjectURL(blob); // URL.createObjectURL(object)表示生成一个File对象或Blob对象
      let dom = document.createElement('a'); // 设置一个隐藏的a标签，href为输出流，设置download
      dom.style.display = 'none';
      dom.href = url;
      dom.setAttribute('download', decodeURI(data.fileName)); // 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
      document.body.appendChild(dom);
      dom.click();
    },
    str2Blob(str, mime) {
      var arr = str.split(',')
      var bstr = atob(arr[0]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime
      });
    },
    // 发布
    pushEmail() {
      if (this.dataListSelections.length === 0) {
        this.$message.warning("请选择交货单")
        return
      }
      this.$confirm(`确定进行补发邮件操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = this.dataListSelections.map(item => {
          return item.id
        })
        pushEmail(ids).then(data => {
          if (data && data.code === '00') {
            this.$message({
              message: '补发邮件成功',
              type: 'success',
              duration: 300,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
  }
}
</script>
